export default __webpack_public_path__ + "static/media/img1.35c11f68.png";